// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federsteifigkeit/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federsteifigkeitDE: PageEntry = {
  id: "post.federsteifigkeit",
  locale: "de",
  slug: "federsteifigkeit",
  seo: {
    title: "Glossar: Federsteifigkeit einfach erklärt | Dietz GmbH",
    description: "Die Federsteifigkeit, auch als Federkonstante bekannt, ist ein Maß für die Steifheit einer Feder. Sie gibt an, wie viel Kraft erforderlich ist, um die Feder um eine Einheit zu dehn",
  },
  type: "post",
  h1: "Glossar: Federsteifigkeit einfach erklärt",
  intro: "Die Federsteifigkeit, auch als Federkonstante bekannt, ist ein Maß für die Steifheit einer Feder. Sie gibt an, wie viel Kraft erforderlich ist, um die Feder um eine Einheit zu dehnen oder zu komprimieren. Die Federsteifigkeit wird in Newton pro Meter (N/m) gemessen. Eine höhere Federsteifigkeit bedeutet, dass die Feder steifer ist, während eine niedrigere Steifigkeit auf eine weichere Feder hinweist. Die genaue Kenntnis der Federsteifigkeit ist entscheidend für die Auslegung von Feder-Systemen in verschiedenen Anwendungen, von Fahrzeugfahrwerken bis zu industriellen Maschinen.",
  blocks: [

  ],
};
